import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import s from './styles.module.scss';

const NoTableData = ({ t, title }) => <h2 className={s.noDataInfo}>{title || t('tableNoData')}</h2>;

NoTableData.defaultProps = {
  title: false,
};

NoTableData.propTypes = {
  t: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default withTranslation()(NoTableData);
